import React from 'react'

import MasterCard from '@images/mastercard.png'

export default (props) =>
  <img {...props} src={MasterCard}></img>
